import { Component, Inject, OnDestroy } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { Subscription } from 'rxjs';
import { DialogButtonComponent } from "../buttons/dialog-button.component";
import { CommonModule } from '@angular/common';
import { TranslateService } from '../../services/translate.service';
import { AppStateService } from '../../services/app-state.service';

@Component({
  standalone: true,
  imports: [DialogButtonComponent, CommonModule],
  template: `
    <div class="bg-theme-surface text-theme-text p-6 rounded-2xl shadow-xl max-w-sm mx-auto">
      <div class="text-center mb-6">
        <div class="w-16 h-16 bg-theme-primary-50 rounded-full flex items-center justify-center mx-auto mb-4">
          <i class="fas fa-receipt text-theme-primary text-2xl"></i>
        </div>
        <h2 class="text-xl font-bold mb-2">{{ translate.getString('Kvitto') }}</h2>
        <p class="text-theme-text2 text-sm">{{ translate.getString('Önskar du få kvitto via e-post?') }}</p>
      </div>

      <div class="flex gap-3">
        <button
          (click)="close()"
          class="flex-1 px-4 py-3 border border-theme-outline rounded-xl text-theme-text2 font-medium hover:bg-theme-surface2 transition-colors">
          {{ translate.getString('Nej tack') }}
        </button>
        <button
          (click)="showEmailDialog()"
          class="flex-1 px-4 py-3 bg-theme-primary text-theme-contrast rounded-xl font-medium hover:bg-opacity-90 transition-colors">
          {{ translate.getString('Ja tack') }}
        </button>
      </div>
    </div>
  `
})
export class ReceiptPromptDialogComponent implements OnDestroy {
  private sub = new Subscription();

  constructor(
    private modalService: ModalService,
    public translate: TranslateService,
    private appStateService: AppStateService,
    @Inject('MODAL_DATA') public data: any
  ) {}

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  close(): void {
    this.modalService.close(false);
  }

  showEmailDialog(): void {
    // Close current dialog and return true to navigate to receipt page
    this.modalService.close(true);
  }
}